<template>
  <article class="info-post-block">
    <div class="row-noGutter">
      <div
        v-if="imageUrl || image"
        class="col-12 col_md-4"
      >
        <div
          class="info-post-block__image-wrapper"
        >
          <img
            v-if="imageUrl"
            :src="imageUrl"
            :alt="imageAlt"
          >
          <epi-picture
            v-if="!imageUrl && image"
            :use-picture="true"
            :auto-aspect-ratio="false"
            :image="(!imageUrl && image) && image"
            edit="Image"
          />
        </div>
      </div>
      <div
        class="col-12 info-post-block__content-wrapper"
        :class="imageUrl || image ? 'col_md-8 info-post-block--content-wrapper-order' : 'col_lg-8'"
      >
        <h2
          v-if="title"
          class="info-post-block__post-title"
          v-text="title"
        />
        <p
          v-if="authorDate"
          class="info-post-block__post-date"
          v-text="dateFormat(authorDate)"
        />
        <p
          v-if="preamble"
          class="info-post-block__preamble"
          v-text="preamble"
        />
        <link-wrapper
          :url="url"
          :title="linkText"
        />
      </div>
    </div>
  </article>
</template>

<script>
import dateFormat from "dateformat"
dateFormat.i18n = {
  dayNames: [
    "Sön",
    "Mån",
    "Tis",
    "Ons",
    "Tor",
    "Fre",
    "Lör",
    "Söndag",
    "Måndag",
    "Tisdag",
    "Onsdag",
    "Torsdag",
    "Fredag",
    "Lördag"
  ],
  monthNames: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "Maj",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Okt",
    "Nov",
    "Dec",
    "Januari",
    "Februari",
    "Mars",
    "April",
    "Maj",
    "Juni",
    "Juli",
    "Augusti",
    "September",
    "Oktober",
    "November",
    "December"
  ],
  timeNames: ["a", "p", "am", "pm", "A", "P", "AM", "PM"]
}
import linkWrapper from '@/vue/components/linkWrapper/linkWrapper'
export default {
  name: "InfoPostBlock",
  components: {
    linkWrapper,
  },
  props: {
    title: {
      type: String,
      default: ""
    },
    authorDate: {
      type: String,
      default: ""
    },
    preamble: {
      type: String,
      default: ""
    },
    url: {
      type: String,
      default: ""
    },
    linkText: {
      type: String,
      default: "Läs mer"
    },
    imageUrl: {
      type: String,
      default: ""
    },
    imageAlt: {
      type: String,
      default: ""
    },
    image : {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    dateFormat: date => {
      return dateFormat(new Date(date), "d mmmm yyyy")
    }
  }
}
</script>

<style lang="scss" scoped>
.info-post-block {
  background: $color-white;
  border-radius: 0.25rem;
  box-shadow: $box-shadow-primary;
  padding: 1.5rem 1.5rem 1.5rem 1.5rem;
  margin-bottom: 0.5rem;

  @include media-breakpoint-up(md) {
    padding: 2rem 2.5rem 2rem 2.5rem;
  }

  &__post-title {
    margin: 0 0 0.5rem 0;

    @include font(rubrik, 2, "mid");
  }

  &__post-date {
    margin-top: 0;
    margin-bottom: 1rem;

    @include font(text, 3, "light");
  }

  &__preamble {
    margin: 0;
    margin-bottom: 1.5rem;

    @include font(text, 3, "light");
  }

  &__image-wrapper {
    padding: 1.5rem;
    border: 0.0625rem solid $color-grey-special;
    text-align: center;
    height: 18.4375rem;
    max-width: 100%;
    margin-bottom: 1.5rem;
    box-shadow: 0 0.0625rem 0.125rem 0 rgba(0, 0, 0, 0.06);
    border-radius: 0.25rem;

    @include media-breakpoint-up(md) {
      margin: 0 0 auto auto;
      height: 11.5rem;
      width: 11.5rem;
    }

    @include media-breakpoint-up(lg) {
      height: 14rem;
      width: 14rem;
    }

    img {
      max-height: 100%;
      position: relative;
      top: 50%;
      transform: translateY(-50%);
    }

    .epi-picture,
    .epi-background-container {
      max-height: 100%;
      position: relative;
      top: 50%;
      transform: translateY(-50%);
    }

    .epi-picture:not(.loaded) {
      top: 0;
    }
  }

  &--content-wrapper-order {
    @include media-breakpoint-up(md) {
      order: -1;
    }
  }
}
</style>
